jQuery.noConflict();
jQuery(document).ready(function(){
	// Afficher un nombre limité de fichier (11)
	var allitems = $('.tablist_tag').length;
	var itemsdesk = 7;
	if ( allitems > itemsdesk ) {
		$( '.tablist_more' ).css( 'visibility', 'visible' );
	}
	$('.tablist_tag:lt('+itemsdesk+')').css('display', 'block');
	// End
	// Afficher 2 faq en plus en cliquant sur le boutton voir plus
	$( '.tablist_more' ).click(function() {
		itemsdesk = itemsdesk + 2;
		$('.tablist_tag:lt('+itemsdesk+')').css('display', 'block');
		if ( itemsdesk >= allitems ) {
			$( '.tablist_more' ).hide();
		}
	});
	$( '.tablist_more' ).keypress(function (e) {
		var key = e.which;
		if( (key == 13) || (key == 32) ) 
		{
			itemsdesk = itemsdesk + 2;
			$('.tablist_tag:lt('+itemsdesk+')').css('display', 'block');
			if ( itemsdesk >= allitems ) {
				$( '.tablist_more' ).hide();
			}
			return false;
    }
	});
	// End
	// Show section
	$('.tablist_right:lt("1")').show();
	$( '.tablist_tag' ).click(function() {
		$( '.tablist_tag' ).removeClass('tablist_tag-active');
		$(this).toggleClass('tablist_tag-active');
		var tag = $(this).data('tag');
		$( '.tablist_right' ).hide();
		$('.tablist_right').each(function(i, obj) {
			if ( $(this).data('section') == tag ) {
				$(this).show();
			}
		});
	});
	$( '.tablist_tag' ).keypress(function (e) {
		var key = e.which;
		if( (key == 13) || (key == 32) ) 
		{
			$( '.tablist_tag' ).removeClass('tablist_tag-active');
			$(this).toggleClass('tablist_tag-active');
			var tag = $(this).data('tag');
			$( '.tablist_right' ).hide();
			$('.tablist_right').each(function(i, obj) {
				if ( $(this).data('section') == tag ) {
					$(this).show();
				}
			});
			return false;
		}
	});
	// End Show section
	// Mobile scripts
	$( '.tablist_tag-mob' ).click(function() {
		$(this).find( '.tablist_title-mob' ).toggleClass('tablist_title-mob-active');
		$(this).find( '.tablist_arrow-mob' ).toggleClass('tablist_arrow-mob-active');
		$(this).next( '.tablist_content-mob' ).toggleClass('tablist_content-mob-active');
	});

	var allitems = $('.tablist_item-mob').length;
	var items = 5;
	if ( allitems > items ) {
		$( '.tablist_tagspe-mob' ).css('display', 'flex');
	}
	$('.tablist_item-mob:lt('+items+')').show();

	$( '.tablist_tagspe-mob' ).click(function() {
		items = items + 2;
		$('.tablist_item-mob:lt('+items+')').show();
		if ( items >= allitems ) {
			$( '.tablist_tagspe-mob' ).hide();
		}
	});
		
});



























// jQuery.noConflict();
// jQuery(document).ready(function(){
// 	$('.tablist_tabslist li').click(function(){
        
//         var tab_id = $(this).attr('data-tab');

//         $('.tablist_tabslist li').removeClass('current');
// 		$('.tablist_tab-content').removeClass('current');

//         $(this).addClass('current');
// 		$("#"+tab_id).addClass('current');
// 	});
// });

// jQuery.noConflict();
// jQuery(document).ready(function(){
// 	$('.tablist_load-more-tabs').on("click", function(){
// 		$('.tablist_ghost-tab-link').toggle(150, function(){
// 			$('.tablist_load-more-tabs').text($('.tablist_load-more-tabs').text() == 'En voir plus' ? 'Fermer' : 'En voir plus');
// 		});

// 	});
// });